export default function removeMultipleForwardSlashes(pathname: string): string {
  return pathname.replace(/\/+/g, '/');
}
